<div class="container">
    <div class="loading-overlay" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
    </div>
    
    <form
      class="card-form"
      [formGroup]="motorForm"
      (ngSubmit)="submitForm()"
      novalidate
    >
      <div class="blue-top"></div>
<!-- ====   POLICE DETAILS SECTION   =======  -->
      <div class="card-section top-section" >
        <h1>{{ pageHeading }}</h1>
        <h2>{{ policeSubHeading }}</h2>
        <mat-form-field
            appearance="outline"
            class="form-select"
            appFullYearDateFormat
            >
            <mat-label class="form-select-placeholder-unselected">
                {{ policeDateLabel }}
            </mat-label>
            <mat-hint>{{ policeDateHint }}</mat-hint>
            <input
                matInput
                [min]="minDate"
                [max]="maxDate"
                [matDatepicker]="picker"
                readonly="true"
                (click)="picker.open()"
                formControlName="policeDate"
                (blur)="logErrors()" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker> </mat-datepicker>
            <mat-error *ngIf="formErrors['policeDate']">
                {{ formErrors["policeDate"] }}
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-select">
            <mat-label class="form-select-placeholder-unselected">
                {{ crObNumberLabel }}
            </mat-label>
            <input matInput formControlName="crObNumber" (blur)="logErrors()" />
            <mat-error *ngIf="formErrors['crObNumber']">
                {{ formErrors["crObNumber"] }}
            </mat-error>
        </mat-form-field>

        <mat-form-field
            appearance="outline"
            class="form-select"
            floatLabel="always"
        >
            <mat-label class="form-select-placeholder-unselected">{{ 'Police Station' }}</mat-label>
            <textarea
                matInput
                formControlName="policeStation"
                placeholder="{{ policeStationLabel }}"
                style="height: 70px;"
                (blur)="logErrors()">
            </textarea>
            <mat-error *ngIf="formErrors['policeStation']">
                {{ formErrors["policeStation"] }}
            </mat-error>
      </mat-form-field>
      </div>
<!-- ==== VEHICLE DETAILS SECTION   =======  -->
      <div class="card-section bottom-section" *ngIf="this.type === 'total'">
        <h2>{{ vehicleDetailsSubHeading }}</h2>

        <p>{{ alterationsQuestion }}</p>

        <section formGroupName="alterations" style="margin-bottom: 15px;" >
            <div class="row-div modified_checkbox">
                <div class="row-inner-div row-inner-div-left">
                    <mat-checkbox formControlName="yes" (change)="onYesChange()">{{
                    yesText
                    }}</mat-checkbox>
                </div>
                <div class="row-inner-div row-inner-div-right">
                    <mat-checkbox formControlName="no" (change)="onNoChange()">{{
                    noText
                    }}</mat-checkbox>
                </div>
            </div>

            <mat-error> {{ formGroupErrors["alterations"] }} </mat-error>
        </section>

        <mat-form-field
            appearance="outline"
            class="form-select"
            floatLabel="always"
            *ngIf="motorForm.controls['alterations'].controls['yes'].value === true"
        >
            <mat-label class="form-select-placeholder-unselected">{{ 'Details' }}</mat-label>
            <textarea
                matInput
                formControlName="alterationDetails"
                placeholder="{{ giveDetailsLabel }}"
                style="height: 70px;"
                (blur)="logErrors()">
            </textarea>
            <mat-error *ngIf="formErrors['alterationDetails']">
                {{ formErrors["alterationDetails"] }}
            </mat-error>
        </mat-form-field>

        <p>{{ fitmentsQuestion }}</p>

        <section formGroupName="fitments" style="margin-bottom: 15px;" >
            <div class="row-div modified_checkbox">
                <div class="row-inner-div row-inner-div-left">
                    <mat-checkbox formControlName="yes" (change)="onYes2Change()">{{
                    yesText
                    }}</mat-checkbox>
                </div>
                <div class="row-inner-div row-inner-div-right">
                    <mat-checkbox formControlName="no" (change)="onNo2Change()">{{
                    noText
                    }}</mat-checkbox>
                </div>
            </div>

            <mat-error> {{ formGroupErrors["fitments"] }} </mat-error>
        </section>

        <mat-form-field
                appearance="outline"
                class="form-select"
                floatLabel="always"
                *ngIf="motorForm.controls['fitments'].controls['yes'].value === true"
            >
                <mat-label class="form-select-placeholder-unselected">{{ 'Details' }}</mat-label>
                <textarea
                    matInput
                    formControlName="fitmentDetails"
                    placeholder="{{ giveDetailsLabel }}"
                    style="height: 70px;"
                    (blur)="logErrors()">
                </textarea>
                <mat-error *ngIf="formErrors['fitmentDetails']">
                    {{ formErrors["fitmentDetails"] }}
                </mat-error>
        </mat-form-field>

        <p>{{ identifiersQuestion }}</p>

        <section formGroupName="identifiers" style="margin-bottom: 15px;" >
            <div class="row-div modified_checkbox">
                <div class="row-inner-div row-inner-div-left">
                    <mat-checkbox formControlName="yes" (change)="onYes3Change()">
                        {{ yesText }}
                </mat-checkbox>
                </div>
                <div class="row-inner-div row-inner-div-right">
                    <mat-checkbox formControlName="no" (change)="onNo3Change()">{{
                    noText
                    }}</mat-checkbox>
                </div>
            </div>

            <mat-error> {{ formGroupErrors["identifiers"] }} </mat-error>
        </section>
        
        <mat-form-field
                appearance="outline"
                class="form-select"
                floatLabel="always"
                *ngIf="motorForm.controls['identifiers'].controls['yes'].value === true"
            >
                <mat-label class="form-select-placeholder-unselected">{{ 'Details' }}</mat-label>
                <textarea
                    matInput
                    formControlName="identifierDetails"
                    placeholder="{{ giveDetailsLabel }}"
                    style="height: 70px;"
                    (blur)="logErrors()">
                </textarea>
                <mat-error *ngIf="formErrors['identifierDetails']">
                    {{ formErrors["identifierDetails"] }}
                </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
            <mat-label class="form-select-placeholder-unselected">
                {{ mileageLabel }}
            </mat-label>
            <input matInput formControlName="mileage" (blur)="logErrors()" />
            <mat-error *ngIf="formErrors['mileage']">
                {{ formErrors["mileage"] }}
            </mat-error>
        </mat-form-field>
        
  
      </div>
<!-- ==== PARTS DETAILS SECTION   =======  -->
      <div class="card-section bottom-section" *ngIf="this.type === 'partial'" >
        <h2>{{ partsDetailsSubHeading }}</h2>
  
        <div formArrayName="partDetails">
          <div *ngFor="let partDetail of getParts().controls; let i=index" [formGroupName]="i">
  
            <div class="row-div-reverse remove-stroked-button" *ngIf="i > 0" >
                <button mat-stroked-button type="button" (click)="removePart(i)">
                    <span class="button-text">{{ remove }}</span>
                </button>
            </div>
  
            <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                    {{ partDescLabel }}
                </mat-label>
                <input matInput formControlName="partDesc" (blur)="logErrors()" />
                <mat-error *ngIf="formErrors['partDesc']">
                    {{ formErrors["partDesc"] }}
                </mat-error>
            </mat-form-field>
  
            <mat-form-field appearance="outline" class="form-select" style="width: 100%;"
                *ngIf="this.replaced === 'true'" >
                <mat-label class="form-select-placeholder-unselected">
                    {{pricePaidLabel}}
                </mat-label>
                <input matInput formControlName="pricePaid" (blur)="logErrors()" spellcheck="false" maxlength="12"/>
                <mat-error *ngIf="formErrors['pricePaid']">
                    {{ formErrors["pricePaid"] }}
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select" style="width: 100%;"
                *ngIf="this.replaced === 'true'" >
                <mat-label class="form-select-placeholder-unselected">
                    {{ dealerLabel }}
                </mat-label>
                <input matInput formControlName="dealer" (blur)="logErrors()" />
                <mat-error *ngIf="formErrors['dealer']">
                    {{ formErrors["dealer"] }}
                </mat-error>
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="form-select"
                style="width: 100%;"
                appFullYearDateFormat
                *ngIf="this.replaced === 'true'" >
            <mat-label class="form-select-placeholder-unselected">{{
                purchaseDateLabel
            }}</mat-label>
            <input
                matInput
                [min]="minDate"
                [max]="maxDate"
                [matDatepicker]="picker2"
                readonly="true"
                (click)="picker2.open()"
                formControlName="purchaseDate"
                (blur)="logErrors()"
            />
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2> </mat-datepicker>
            <mat-error *ngIf="formErrors['purchaseDate']">
                {{ formErrors["purchaseDate"] }}
            </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select" style="width: 100%;">
                <mat-label class="form-select-placeholder-unselected">
                    {{claimedAmountLabel}}
                </mat-label>
                <input matInput formControlName="claimedAmount" (blur)="logErrors()" spellcheck="false" maxlength="12"/>
                <mat-error *ngIf="formErrors['claimedAmount']">
                    {{ formErrors["claimedAmount"] }}
                </mat-error>
            </mat-form-field>
  
            <div class="divider-line"></div>
          </div>
        </div>
  
        <!-- BUTTTON aDD Part -->
        <div class="row-div general-stroked-button">
          <button mat-stroked-button type="button" (click)="addNewPart()">
            <span class="button-text">+&nbsp;&nbsp;{{ moreStolenPartsText }}</span>
          </button>
        </div>
        
      </div>
<!-- ======    PREVIOUS CLAIMS SECTION    ======= -->
      <div class="card-section bottom-section">
        <h2>{{ previousClaimsLabel }}</h2>

        <p>{{ otherInsurancesQuestion }}</p>

        <section formGroupName="otherInsurances" style="margin-bottom: 15px;" >
            <div class="row-div modified_checkbox">
                <div class="row-inner-div row-inner-div-left">
                    <mat-checkbox formControlName="yes" (change)="onYes4Change()">{{
                    yesText
                    }}</mat-checkbox>
                </div>
                <div class="row-inner-div row-inner-div-right">
                    <mat-checkbox formControlName="no" (change)="onNo4Change()">{{
                    noText
                    }}</mat-checkbox>
                </div>
            </div>

            <mat-error> {{ formGroupErrors["otherInsurances"] }} </mat-error>
        </section>

        <p>{{ previousTheftsQuestion }}</p>

        <section formGroupName="previousThefts" style="margin-bottom: 15px;" >
            <div class="row-div modified_checkbox">
                <div class="row-inner-div row-inner-div-left">
                    <mat-checkbox formControlName="yes" (change)="onYes5Change()">{{
                    yesText
                    }}</mat-checkbox>
                </div>
                <div class="row-inner-div row-inner-div-right">
                    <mat-checkbox formControlName="no" (change)="onNo5Change()">{{
                    noText
                    }}</mat-checkbox>
                </div>
            </div>

            <mat-error> {{ formGroupErrors["previousThefts"] }} </mat-error>
        </section>

        <mat-form-field
            appearance="outline"
            class="form-select"
            floatLabel="always"
            *ngIf="motorForm.controls['previousThefts'].controls['yes'].value === true"
        >
            <mat-label class="form-select-placeholder-unselected">{{ 'Details' }}</mat-label>
            <textarea
                matInput
                formControlName="previousTheftDetails"
                placeholder="{{ previousTheftsLabel }}"
                style="height: 70px;"
                (blur)="logErrors()">
            </textarea>
            <mat-error *ngIf="formErrors['previousTheftDetails']">
                {{ formErrors["previousTheftDetails"] }}
            </mat-error>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="form-select"
          style="margin-bottom: 10px;"
          *ngIf="motorForm.controls['previousThefts'].controls['yes'].value === true ||
            motorForm.controls['otherInsurances'].controls['yes'].value === true">
            <mat-label class="form-select-placeholder-unselected">
                {{ insuranceCompanyLabel }}
            </mat-label>
            <mat-hint>{{ insuranceCompanyHint }}</mat-hint>
            <input matInput formControlName="insuranceCompany" (blur)="logErrors()" />
            <mat-error *ngIf="formErrors['insuranceCompany']">
                {{ formErrors["insuranceCompany"] }}
            </mat-error>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="form-select"
          appFullYearDateFormat
          *ngIf="motorForm.controls['previousThefts'].controls['yes'].value === true"
        >
          <mat-label class="form-select-placeholder-unselected">{{
            previousClaimDateLabel
          }}</mat-label>
          <input
            matInput
            [min]="minDate"
            [max]="maxDate"
            [matDatepicker]="picker3"
            readonly="true"
            (click)="picker3.open()"
            formControlName="previousClaimDate"
            (blur)="logErrors()"
          />
          <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
          <mat-datepicker #picker3> </mat-datepicker>
          <mat-error *ngIf="formErrors['previousClaimDate']">
            {{ formErrors["previousClaimDate"] }}
          </mat-error>
        </mat-form-field>
  
      </div>
<!-- ======    LAST SECTION    ======= -->
      <div class="card-section bottom-section">
        <mat-form-field appearance="outline" class="form-select">
          <mat-label class="form-select-placeholder-unselected">{{
            nameLabel
          }}</mat-label>
          <input matInput formControlName="name" (blur)="logErrors()" />
          <mat-error *ngIf="formErrors['name']">
            {{ formErrors["name"] }}
          </mat-error>
        </mat-form-field>
  
        <mat-form-field
          appearance="outline"
          class="form-select"
          appFullYearDateFormat
        >
          <mat-label class="form-select-placeholder-unselected">{{
            dateLabel
          }}</mat-label>
          <input
            matInput
            [min]="maxDate"
            [max]="maxDate"
            [matDatepicker]="picker4"
            readonly="true"
            (click)="picker4.open()"
            formControlName="date"
            (blur)="logErrors()"
          />
          <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
          <mat-datepicker #picker4> </mat-datepicker>
          <mat-error *ngIf="formErrors['date']">
            {{ formErrors["date"] }}
          </mat-error>
        </mat-form-field>
  
        <div class="simple_checkbox width-100pc margin-bottom-40 margin-top-30">
          <mat-checkbox formControlName="iSwear" (blur)="logErrors()" style="margin-bottom: 10px;">
            <p class="checkbox-p" [innerHTML]="iSwearText | dompurify"></p>
          </mat-checkbox>
          <mat-error *ngIf="formErrors['iSwear']">
            {{formErrors["iSwear"]}}
          </mat-error>
        </div>
  
        <div class="row-div">
          <button mat-stroked-button type="button" (click)="cancelApplication()">
            <span class="button-text">{{ cancelText }}</span>
          </button>
          <button mat-button type="submit" [disabled]="motorForm.controls['iSwear'].value === false || !motorForm.valid">
            <span class="button-text">{{ saveText }}</span>
          </button>
        </div>
      </div>
    </form>
  </div>
  
